import { actionCreatorFactory } from 'typescript-fsa'
import { SnackbarText } from '../../types'

const actionCreator = actionCreatorFactory()

export const createSnackbar = actionCreator<SnackbarText>('createSnackbar')
export const clearSnackbar = actionCreator('clearSnackbar')
